export default "__VITE_ASSET__YWuZAvlN__"